import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./paytronix_gift_auth_source.js";
//#region src/paytronix_gift_auth_source_helper.ts
var paytronix_gift_auth_source_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(authSource) {
	switch (authSource) {
		case "direct": return "Paytronix Gift Card Direct";
		case "olo": return "Paytronix Olo";
	}
}
//#endregion
export { name, paytronix_gift_auth_source_helper_exports };

//# sourceMappingURL=paytronix_gift_auth_source_helper.js.map